<template>
  <div>
    <nav
      class="bg-white lg:pt-3 md:mb-4 mx-auto"
      :class="{
        'container bg-white pt-3 md:mb-4 mx-auto h-30' : isCoursesPage, // for courses pages do not show nav on scroll up
        'fixed top-0 left-0 right-0 z-50 lg:h-24' : !isCoursesPage, // any other page show nav on scroll up
        'transform -translate-y-full': !showNavbar, // this hides the navbar on scroll down
        'transition-transform duration-300 ease-in-out transform translate-y-0': showNavbar && !isCoursesPage, //this shows the navbar on scroll up if not /courses page
      }"
    >
      <t-container>
        <div
          :class="{'hidden': !showMenu, 'flex': showMenu}"
          class="lg:flex lg:flex-grow">
          <ul class="flex flex-col lg:flex-row list-none ml-auto pt-3">
            <li>
              <a
                href="tel:+18004339570"
                class="px-2 text-xs flex items-center leading-snug text-black hover:opacity-75">
                <span><t-icon
                  name="mobile-alt"
                  class="text-text-primary hover:text-primary-120 text-sm"
                  style="cursor: pointer;" /> (800) 433-9570</span>
              </a>
            </li>
            <li>
              <nuxt-link
                to="/about"
                class="px-2 text-xs flex items-center leading-snug text-black hover:opacity-75">
                About
              </nuxt-link>
            </li>
            <li>
              <a
                href="https://summit-education.com/blog/"
                target="_blank"
                class="px-2 text-xs flex items-center leading-snug text-black hover:opacity-75">
                Blog
              </a>
            </li>
            <li>
              <nuxt-link
                to="/support"
                target="_blank"
                class="px-2 text-xs flex items-center leading-snug text-black hover:opacity-75">
                Customer Support
              </nuxt-link>
            </li>
          </ul>
        </div>
        <div
          :class="{ hidden: !showMenu, flex: showMenu }"
          class="lg:flex lg:flex-grow h-6 justify-between items-center"
        >
          <NuxtLink
            to="/"
            class=" mr-4 h-22 -mt-12"
          >
            <nav-logo />
          </NuxtLink>
          <nav-search-nav />
          <t-nav-dropdown
            variant="nav"
            :placeholder="'Courses'"
            @send-event-gtm="sendEvent('nav-first-level', 'courses', 'courses', 'courses', '');"
          >
            <template
              #dropdown-content
            >
              <div>
                <div class="p-4 grid grid-rows-1 grid-flow-col auto-cols-max">
                  <div>
                    <nuxt-link to="/profession">
                      <button
                        id="professions"
                        class="nav-second-level block font-bold w-full px-2 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                        @click="sendEvent('nav-second-level', 'profession', 'profession', 'profession', '/profession' );"
                      >
                        Professions
                      </button>
                    </nuxt-link>
                    <div
                      v-for="(profession, id) in navItems.course.professions"
                      :key="id"
                    >
                      <a :href="profession.link">
                        <button
                          :id="profession.id"
                          class="nav-third-level block w-full px-4 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                          :class="profession.id"
                          @click="sendEvent('nav-third-level', course.title, course.id, course.id, course.link ); hide();"
                        >
                          {{ profession.title }}
                        </button>
                      </a>
                    </div>
                    <nuxt-link to="/certification-series">
                      <button
                        id="certification-series"
                        class="block font-bold w-full px-2 py-3 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120 nav-second-level certification-series"
                        @click="sendEvent('nav-second-level', 'certification-series', 'certification-series', 'certification-series', '/certification-series' ); hide();"
                      >
                        Certification Series
                      </button>
                    </nuxt-link>
                    <nuxt-link to="/signature-series/stroke-symposium/nashville-july-2025">
                      <button
                        id="stroke-symposium-2025"
                        class="block font-bold w-full px-2 py-3 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120 nav-second-level certification-series"
                        @click="sendEvent('nav-second-level', 'stroke-symposium-2025', 'stroke-symposium-2025', 'stroke-symposium-2025', '/signature-series/stroke-symposium/nashville-july-2025' ); hide();"
                      >
                        Stroke Symposium 2025
                      </button>
                    </nuxt-link>
                  </div>
                  <div>
                    <nuxt-link to="/topics">
                      <button
                        id="topics"
                        class="block font-bold w-full px-2 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120 nav-second-level topics"
                        @click="sendEvent('nav-second-level', 'topics', 'topics', 'topics', '/topics' );"
                      >
                        Topics
                      </button>
                    </nuxt-link>
                    <div
                      v-for="(topic, id) in navItems.course.topics"
                      :key="id"
                    >
                      <a :href="topic.link">
                        <button
                          :id="topic.id"
                          class="nav-third-level block w-full px-4 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                          :class="topic.id"
                          @click="sendEvent('nav-third-level', `${topic.title}`, `${topic.id}`, `${topic.id}`, `${topic.link}` )"
                        >
                          {{ topic.title }}
                        </button>
                      </a>
                    </div>
                  </div>
                  <div>
                    <nuxt-link to="/formats">
                      <button
                        class="nav-second-level block font-bold w-full px-2 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                        @click="sendEvent('nav-second-level', 'formats', 'formats', 'formats', '/formats' );"
                      >
                        Formats
                      </button>
                    </nuxt-link>
                    <div
                      v-for="(format, id) in navItems.course.formats"
                      :key="id"
                    >
                      <a :href="format.link">
                        <button
                          :id="format.id"
                          :class="format.id"
                          class="nav-third-level block w-full px-4 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                          @click="sendEvent('nav-third-level', `${format.title}`, `${format.id}`, `${format.id}`, `${format.link}` )"
                        >
                          {{ format.title }}
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </template></t-nav-dropdown>
          <t-nav-dropdown
            variant="nav"
            :placeholder="'Instructors'"
            @send-event-gtm="sendEvent('nav-first-level', 'subscriptions', 'subscriptions', 'subscriptions', '')"
          >
            <template
              #dropdown-content
            >
              <div>
                <div class="p-4 grid grid-rows-1 grid-flow-col auto-cols-max">
                  <div>
                    <nuxt-link to="/instructor/directory">
                      <button
                        id="instructors"
                        class="nav-second-level instructors block font-bold w-full py-2 px-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                        @click="sendEvent('nav-second-level', 'instructors', 'instructors', 'instructors', '/instructor/directory' );"
                      >
                        Instructors
                      </button>
                    </nuxt-link>
                    <div
                      v-for="(instructor, id) in navItems.instructors"
                      :key="id"
                    >
                      <a :href="instructor.link">
                        <button
                          class="nav-third-level block w-full px-4 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                          @click="sendEvent('nav-third-level', `${instructor.title}`, `${instructor.id}`, `${instructor.id}`, `${instructor.link}` )"
                        >
                          {{ instructor.title }}
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </t-nav-dropdown>
          <t-nav-dropdown
            variant="nav"
            :placeholder="'Subscriptions'"
            @send-event-gtm="sendEvent('nav-first-level', 'subscriptions', 'subscriptions', 'subscriptions', '');"
          >
            <template
              #dropdown-content
            >
              <div>
                <div class="p-4 grid grid-rows-1 grid-flow-col auto-cols-max">
                  <div>
                    <nuxt-link to="/subscription/subscription-v2">
                      <button
                        class="nav-second-level block font-bold w-full py-2 px-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                        @click="sendEvent('nav-second-level', 'subscriptions', 'subscriptions', 'subscriptions', '/subscription/subscription-v2' );"
                      >
                        Subscriptions
                      </button>
                    </nuxt-link>
                    <div
                      v-for="(subscription, id) in navItems.subscription"
                      :key="id"
                    >
                      <nuxt-link :to="subscription.link">
                        <button
                          class="nav-third-level block w-full px-4 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                          @click="sendEvent('nav-third-level', `${subscription.title}`, `${subscription.id}`, `${subscription.id}`, `${subscription.link}` )"
                        >
                          {{ subscription.title }}
                        </button>
                      </nuxt-link>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </t-nav-dropdown>
          <!-- TODO: check this click event, was on button but putting it here may make it send the event on everything click in the dropdown? -->
          <t-nav-dropdown
            variant="nav"
            :placeholder="'Group Sales'"
            @send-event-gtm="sendEvent('nav-first-level', 'group-sales', 'group-sales', 'group-sales', '');"
          >
            <template
              #dropdown-content
            >
              <div>
                <div class="p-4 grid grid-rows-1 grid-flow-col gap-2 auto-cols-max">
                  <div>
                    <nuxt-link to="#">
                      <button
                        class="solutions-by-setting block font-bold w-full px-2 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none nav-second-level"
                        @click="sendEvent('nav-second-level', 'group-sales', 'group-sales', 'group-sales', '');"
                      >
                        Solutions for Organizations
                      </button>
                    </nuxt-link>
                    <div
                      v-for="(groupSale, id) in navItems.groupSales.settings"
                      :key="id"
                    >
                      <nuxt-link :to="groupSale.link">
                        <button
                          class="block w-full px-4 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                          @click="sendEvent('nav-third-level', `${groupSale.title}`, `${groupSale.id}`, `${groupSale.id}`, `${groupSale.link}` )"
                        >
                          {{ groupSale.title }}
                        </button>
                      </nuxt-link>
                    </div>
                  </div>
                  <div>
                    <nuxt-link to="/group-sales">
                      <button
                        id="group-solutions"
                        class="group-solutions nav-second-level block font-bold w-full px-2 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                        @click="sendEvent('nav-second-level', 'group-sales', 'group-sales', 'group-sales', '/group-sales' );"
                      >
                        Group/Corporate Solutions
                      </button>
                    </nuxt-link>
                    <div
                      v-for="(groupSale, id) in navItems.groupSales.ceSolutions"
                      :key="id"
                    >
                      <nuxt-link :to="groupSale.link">
                        <button
                          :id="groupSale.id"
                          :class="groupSale.id"
                          class="nav-third-level block w-full px-4 py-2 text-sm leading-5 text-white text-left transition duration-150 ease-in-out border-none hover:bg-primary-120 focus:outline-none focus:bg-primary-120"
                          @click="sendEvent('nav-third-level', `${groupSale.title}`, `${groupSale.id}`, `${groupSale.id}`, `${groupSale.link}` )"
                        >
                          {{ groupSale.title }}
                        </button>
                      </nuxt-link>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </t-nav-dropdown>
          <div v-if="isLoggedIn">
            <template v-if="loading">
              <nuxt-link
                to=""
                class=" flex justify-center items-center w-full"
              >
                <span class="font-bold">My Account</span>
                <div class="animate-spin rounded-full h-4 w-4 ml-4 border-b-2 border-primary-140" />
              </nuxt-link>
            </template>
            <button
              v-else
              class="font-bold leading-loose hover:opacity-75"
              @click="goToAccount"
            >
              My Account
              <t-icon
                name="sign-in-alt"
                class="ml-1 text-text-primary hover:text-primary-120"
                style="cursor: pointer;"
              />
            </button>
          </div>
          <div v-else>
            <nuxt-link
              to="/login"
              class="font-bold leading-loose hover:opacity-75"
            >
              Sign In
              <t-icon
                name="sign-in-alt"
                class="ml-1 text-text-primary hover:text-primary-120"
                style="cursor: pointer;"
              />
            </nuxt-link>
          </div>

          <nuxt-link
            to="/cart"
            class="font-bold leading-loose hover:opacity-75"
          >
            <img
              src="//summitproedu.imgix.net/redesign-assets/icons/2025/cart.svg"
              alt="Cart"
              class="h-8 cursor-pointer"
            />
          </nuxt-link>
        </div>
      </t-container>
    </nav>
    <!--    Mobile Nav-->
    <div class="lg:hidden">
      <nav-mobile-nav />
    </div>
  </div>
  <!--    End Mobile Nav-->
</template>

<script>
import { mapActions, } from 'pinia';
import { useSearchStore, } from '~/stores/search';
import navItems from '@/data/navigationItems.json';
import { navClick, } from '@/services/gtmManager';

export default {
  name: 'NavBar',
  setup() {
    // referencing just useAuth() works here to handle the loading status in watcher
    const { status } = useNuxtApp().$auth;
    return { status };
  },
  data() {
    return {
      showMenu: false,
      navItems,
      lastScrollY: 0,
      showNavbar: true, // initially shown
      loading: ref(false),
      isLoggedIn: ref(false),
    };
  },
  computed: {
    isCoursesPage() {
      return this.$route.path.includes('courses');
    },
  },
  watch: {
    $route(to, from) {
      if (to.name === 'account') {
        this.loading = false;
      }
    },
    status: {
      handler(loggedInStatus) {
        this.isLoggedIn = loggedInStatus === 'authenticated';
        this.loading = loggedInStatus === 'loading';
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(useSearchStore, [
      'setState', 'setProfession', 'applyFilters',
    ]),
    toggleNavbar() {
      this.showMenu = !this.showMenu;
    },
    goToAccount() {
      if (this.$route.name !== 'account') {
        this.loading = true;
        this.$router.push('/account');
      }
    },
    sendEvent(eventName, linkClick, linkId, linkClass, linkUrl) {
      navClick(eventName, linkClick, linkId, linkClass, linkUrl);
    },
    handleScroll() {
      const currentScrollY = window.scrollY;

      if (currentScrollY < this.lastScrollY) {
        this.showNavbar = true; // scrolling up
      } else if (currentScrollY > 100) {
        this.showNavbar = false; // scrolling down
      }

      this.lastScrollY = currentScrollY;
    },
  },
};
</script>

<style scoped>
button {
  font-size: 16px;
}
</style>
